import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import "./SignIn.css";
import { auth } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";

export const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const navigate = useNavigate();
  const handleEmail = (e) => {
    const regex = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
    if (e.target.value === "" && !regex.test(email)) {
      setShowError(true);
    } else {
      setShowError(false);
    }
    setEmail(e.target.value);
  };
  const handlePassword = (e) => {
    if (e.target.value === "") {
      setPasswordError(true);
    } else {
      setPasswordError(false);
    }
    setPassword(e.target.value);
  };
  const handleSignIn = () => {
    if (password === "" || email === "") {
      setPasswordError(true);
      setShowError(true);
    } else {
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          setTimeout(() => {
            navigate("/admin", { state: { email: user.email, uid: user.uid } });
          }, 1500);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode, errorMessage);
        });
    }
  };
  return (
    <div className="container-fluid">
      <div className="container">
        <div className="row mt-5">
          <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 my-5 mx-auto">
            <div className="card border-0 shadow p-sm-5 p-4">
              <div id="sign-in-button" className="d-none" />
              <div className="sigin_section">
                <h3 className="header_heading text-center font-weight-bold  mb-3">
                  تسجيل الدخول
                </h3>

                <div className="form-group mt-5 mb-4 text-end">
                  <label className="mb-2 signIn_label">عنوان البريد الإلكتروني</label>
                  <input
                    type="email"
                    placeholder="أدخل بريدك الإلكتروني"
                    value={email}
                    onChange={handleEmail}
                    className="form-control signup_input"
                    dir="rtl"
                  />
                  <span
                    className={`text-danger ${
                      showError ? "d-block" : "d-none"
                    }`}
                  >
                    Please Enter Valid Email ID
                  </span>
                </div>
                <div className="form-group mb-5 text-end">
                  <label className="mb-2 signIn_label">كلمة المرور</label>
                  <input
                    type="password"
                    placeholder="ادخل رقمك السري"
                    dir="rtl"
                    value={password}
                    onChange={handlePassword}
                    className="form-control signup_input"
                  />
                  <span
                    className={`text-danger ${
                      passwordError ? "d-block" : "d-none"
                    }`}
                  >
                    Please Enter Valid Password
                  </span>
                </div>
                <button
                  type="submit"
                  onClick={handleSignIn}
                  className="btn btn-outline-dark btn-block rounded-pill text-center LoginButton"
                >
                  تسجيل الدخول
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
